import React, { ComponentProps, memo } from 'react'

import styled from '@emotion/styled'

import { DotsVerticalSmall } from '@surglogs-app/icons'

import { Box } from '../Box'
import { Icon } from '../Icon'

const StyledContainer = styled(Box)`
  display: inline-block;
  cursor: pointer;
  flex-shrink: 0;
  padding-top: ${({ theme, pt }) => theme.ui.spacings[pt ?? 'abs.12']};
`

export const ReorderHandler = memo(
  ({ ...props }: ComponentProps<typeof Box>) => (
    <StyledContainer {...{ color: 'navy.100' }} {...props}>
      <Icon {...{ icon: DotsVerticalSmall, color: 'inherit' }} />
    </StyledContainer>
  ),
)
